export default __webpack_public_path__ + "static/media/box-back.e51033d0.webp";